import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    var token = this._cS.getTokenObj();
    document.title = (route.data['title'] ? route.data['title'] : 'Login') + ' - Badeloft Inventory Management';
    if (token != null) {
      return true;
    }
    else {
      this._router.navigate(['login']);
      return false;
    }
  }

  constructor(
    private _router: Router,
    private _cS: CommonService,
  ) { }

}
